<div class="d-flex justify-content-between align-items-center" *ngIf="totalPages > 0">
  <div class="d-flex justify-content-between align-items-center" *ngIf="showInfo">
    <div>
      <small class="text-muted">
        {{ getStartRecord() }} a {{ getEndRecord() }} de {{ totalElements }} itens
      </small>
    </div>
    <div></div>
  </div>
  
  <nav *ngIf="totalPages > 1" class="d-flex justify-content-center flex-grow-1">
    <ul class="pagination" [class]="'pagination-' + size + ' mb-0'">
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="javascript:void(0)" (click)="onPageChange(0)" *ngIf="currentPage > 0" title="Primeira página">
          <i class="fas fa-angle-double-left"></i>
        </a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="javascript:void(0)" (click)="onPageChange(currentPage - 1)" *ngIf="currentPage > 0" title="Página anterior">
          <i class="fas fa-angle-left"></i>
        </a>
      </li>

      <ng-container *ngIf="getVisiblePages().length > 0">
        <li class="page-item" *ngIf="getVisiblePages()[0] > 1" [class.active]="0 === currentPage">
          <a class="page-link" href="javascript:void(0)" (click)="onPageChange(0)">1</a>
        </li>
        
        <li class="page-item disabled" *ngIf="getVisiblePages()[0] > 2">
          <span class="page-link">...</span>
        </li>

        <li class="page-item" *ngFor="let page of getVisiblePages()" [class.active]="page === currentPage">
          <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page + 1 }}</a>
        </li>

        <li class="page-item disabled" *ngIf="getVisiblePages()[getVisiblePages().length - 1] < totalPages - 2">
          <span class="page-link">...</span>
        </li>

        <li class="page-item" *ngIf="getVisiblePages()[getVisiblePages().length - 1] < totalPages - 1" [class.active]="totalPages - 1 === currentPage">
          <a class="page-link" href="javascript:void(0)" (click)="onPageChange(totalPages - 1)">{{ totalPages }}</a>
        </li>
      </ng-container>

      <li class="page-item" [class.disabled]="currentPage === totalPages - 1">
        <a class="page-link" href="javascript:void(0)" (click)="onPageChange(currentPage + 1)" *ngIf="currentPage < totalPages - 1" title="Próxima página">
          <i class="fas fa-angle-right"></i>
        </a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages - 1">
        <a class="page-link" href="javascript:void(0)" (click)="onPageChange(totalPages - 1)" *ngIf="currentPage < totalPages - 1" title="Última página">
          <i class="fas fa-angle-double-right"></i>
        </a>
      </li>
    </ul>
  </nav>
</div>
